// extracted by mini-css-extract-plugin
export default {"donate":"index_donate_7cIqr"};